import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — polished concrete floor. Same 1x1 m / 0.06-thick slab
// convention as floor-wood; one subtle tone strip breaks the monotony.
const CONCRETE = "#9a9a94";
const CONCRETE_LIGHT = "#a5a59f";

export const floorConcrete = defineModel({
  id: "floor-concrete",
  batchId: "modern",
  name: "Concrete floor",
  tags: ["modern", "interior", "structure", "floor", "concrete"],
  summary: "A 1x1 polished concrete floor slab.",
  description:
    "A one-tile polished concrete slab of the Modern Living kit: exactly " +
    "1x1 m and 0.06 m thick, with a single subtle tone variation strip. " +
    "Tiles seamlessly against every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: CONCRETE, position: [0, 0.03, 0] },
      // One subtle lighter band, flush overlay on the slab top.
      { geometry: new THREE.BoxGeometry(1.0, 0.012, 0.22), color: CONCRETE_LIGHT, position: [0, 0.06, 0.18] },
    ];
  },
  animations: [],
});
